import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./home/home.component').then(mod => mod?.HomeComponent)
	},
	// {
	// 	path: '404',
	// 	loadComponent: () => import('./page-not-found/page-not-found.component').then(mod => mod?.PageNotFoundComponent),
	// },
	{
		path: '**',
		loadComponent: () => import('./page-not-found/page-not-found.component').then(mod => mod?.PageNotFoundComponent),
	}
];
